import type { DovolenaRequestType } from '../types'

/** Název modulu v intranetu (menu, záhlaví, e-maily). */
export const DOVOLENA_MODULE_TITLE = 'Žádosti o nepřítomnost'

export const DOVOLENA_MODULE_DESCRIPTION =
  'Dovolená, volno, nemoc, vzdělávání a další typy nepřítomnosti'

export const DOVOLENA_REQUEST_TYPES: DovolenaRequestType[] = [
  'dovolena',
  'neplacene_volno',
  'samostudium',
  'akce_skoly',
  'lekar',
  'nahradni_volno',
  'osobni_duvod',
  'pracovni_neschopnost',
  'sluzebni_cesta',
  'vzdelavani',
  'osetrovani_clena_rodiny',
  'jine',
]

const REQUIRES_DUVOD: DovolenaRequestType[] = ['neplacene_volno', 'jine']

export function dovolenaRequestTypeRequiresDuvod(rt: string | undefined): boolean {
  return REQUIRES_DUVOD.includes(rt as DovolenaRequestType)
}

export function dovolenaRequestTypeRequiresSchoolEvent(rt: string | undefined): boolean {
  return rt === 'akce_skoly'
}

export function dovolenaRequestTypeRequiresEducation(rt: string | undefined): boolean {
  return rt === 'vzdelavani'
}

export function labelDovolenaRequestType(rt: string | undefined): string {
  switch (rt) {
    case 'neplacene_volno':
      return 'Neplacené volno'
    case 'samostudium':
      return 'Samostudium'
    case 'akce_skoly':
      return 'Akce školy'
    case 'lekar':
      return 'Lékař'
    case 'nahradni_volno':
      return 'Náhradní volno'
    case 'osobni_duvod':
      return 'Osobní důvod'
    case 'pracovni_neschopnost':
      return 'Pracovní neschopnost'
    case 'sluzebni_cesta':
      return 'Služební cesta'
    case 'vzdelavani':
      return 'Vzdělávání'
    case 'osetrovani_clena_rodiny':
      return 'Ošetřování člena rodiny'
    case 'jine':
      return 'Jiné'
    default:
      return 'Dovolená'
  }
}

export function dovolenaDuvodPlaceholder(rt: DovolenaRequestType): string {
  if (rt === 'neplacene_volno') return 'Uveďte důvod žádosti o neplacené volno'
  if (rt === 'jine') return 'Uveďte bližší popis důvodu (povinné u typu Jiné)'
  return 'Volitelná poznámka k žádosti'
}

export function dovolenaDuvodFieldLabel(rt: string | undefined): string {
  if (rt === 'neplacene_volno') return 'Důvod'
  if (rt === 'jine') return 'Poznámka / důvod'
  return 'Poznámka'
}

export type DovolenaEmploymentRelation = 'hlavni' | 'vedlejsi'

export function labelDovolenaEmploymentRelation(v: string | undefined): string {
  return v === 'vedlejsi' ? 'Vedlejší pracovní poměr' : 'Hlavní pracovní poměr'
}
